module.exports = __webpack_public_path__ + "img/3.cec24f8f.jpg";